import {Action } from '@ngrx/store';
import {ExerciseModule } from  './traning.module';

export const  SET_AVAILABLE_TRANING ="[traning] set traning";
export const  SET_FINISHED_TRANING ="[traning] set finsihed traning ";
export const  STOP_TRANING="[traning] stop traning";
export const  START_TRANING="[traning]  start traning";

export class  setAvailableTraning implements Action{
        readonly type = SET_AVAILABLE_TRANING;
        constructor(public payload: ExerciseModule[]) {}
};

export class setFinishedTraning implements Action{
    readonly type = SET_FINISHED_TRANING;
    constructor(public payload:ExerciseModule[]){}
};

export class startTraning implements Action{
    readonly type = START_TRANING;
    constructor(public payload:string){}
};

export class stopTraning implements Action{
    readonly type = STOP_TRANING;
    
};

export  type  traningAction = setAvailableTraning | setFinishedTraning | startTraning | stopTraning ;

